import { useTranslation } from "react-i18next";
import { ResetPasswordForm } from "@/components/auth/reset-password-form";

/**
 * Page de réinitialisation de mot de passe
 *
 * Note: La vérification d'authentification et la redirection sont gérées par PublicRoute
 * qui enveloppe cette page dans App.tsx
 */
export default function ResetPasswordPage() {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      {/* Left side with the reset password form */}
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md">
            <ResetPasswordForm />
          </div>
        </div>
      </div>

      {/* Right side with background image */}
      <div className="relative hidden bg-muted lg:block">
        <img
          src="/assets/auth.webp"
          alt={t("app.title")}
          className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.4] "
        />
        <div className="absolute dark:hidden inset-0 bg-gradient-to-t from-foreground/80 to-foreground/0" />
        <div className="absolute bottom-10 left-10 max-w-lg">
          <h1 className="mb-4 text-3xl font-bold text-white drop-shadow-sm">
            {t("auth.createNewPassword")}
          </h1>
          <p className="text-white/90 drop-shadow-sm">
            {t("auth.createNewPasswordMessage")}
          </p>
        </div>
      </div>
    </div>
  );
}
